'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _quickDepositLogic = require('@wh/quick-deposit-logic');

var _components = require('../../components');

var _common = require('../../utils/common');

var _constants = require('../../constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Amount component.
 * @returns {ReactElement} React element
 */
var AmountComponent = function (_Component) {
  (0, _inherits3.default)(AmountComponent, _Component);

  /**
   * Component constructor.
   *
   * @param {object} props element props
   * @public
   */
  function AmountComponent(props) {
    (0, _classCallCheck3.default)(this, AmountComponent);

    var _this = (0, _possibleConstructorReturn3.default)(this, (AmountComponent.__proto__ || (0, _getPrototypeOf2.default)(AmountComponent)).call(this, props));

    _this.updateAmount = _this.updateAmount.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(AmountComponent, [{
    key: 'updateAmount',


    /**
     * updates the amount value after blur
     * @param  {Event} event [event]
     * @return {bool}    returns true
     */
    value: function updateAmount(event) {
      var _this2 = this;

      if (event && event.target) {
        setTimeout(function () {
          return _this2.props.change(_constants.QD_RF_FORM_NAME, _constants.QD_RF_FIELD_AMOUNT, (0, _quickDepositLogic.formatNumber)(event.target.value, 2));
        });
      }
      return true;
    }

    /**
     * Render method for the component
     * @returns {Element<*>} the react element
     */

  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          _props$t = _props.t,
          t = _props$t === undefined ? function () {
        var ctx = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
        return function (msg) {
          return '' + ctx + msg;
        };
      } : _props$t,
          amountValue = _props.amountValue,
          currencyValue = _props.currencyValue,
          currencyCode = _props.currencyCode,
          formElementIndex = _props.formElementIndex;

      return _react2.default.createElement(
        'div',
        { className: 'qd-amount' },
        _react2.default.createElement(
          'div',
          { className: 'qd-amount-label' },
          t(_constants.TRANSLATION_CONTEXT)('FORM_LBL_AMOUNT')
        ),
        _react2.default.createElement(_components.Amount, {
          name: _constants.QD_RF_FIELD_AMOUNT,
          amountLabel: '',
          amountValue: amountValue,
          currencyValue: currencyValue,
          normalize: _common.onlyNumbersDecimals,
          tabIndex: formElementIndex,
          onBlur: this.updateAmount,
          validation: [(0, _common.isRequired)(t(_constants.TRANSLATION_CONTEXT)('VAL_AMOUNT_REQUIRED')), (0, _common.number)(t(_constants.TRANSLATION_CONTEXT)('VAL_AMOUNT_NOT_NUMERIC')), (0, _common.getDepositAmountValidationI18nd)(t(_constants.TRANSLATION_CONTEXT), _quickDepositLogic.PaymentsApi.setFormDepositAmountIfValid, currencyValue, currencyCode)]
        })
      );
    }
  }]);
  return AmountComponent;
}(_react.Component);

exports.default = AmountComponent;